export default __webpack_public_path__ + "31cd7b9f5d49bb04021af9c1a25de38c.png";